import { observable } from "mobx";
import { ManageElement } from "./ManageElement";
import { PackingSizeStore } from "stores/PackingSizeStore";

export class PackingSize extends ManageElement {
  static _store: PackingSizeStore;

  @observable type: string;
}
